import { inject, Injectable } from '@angular/core';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { ConfirmationDialogComponent } from '@libs/shared/ui/dialogs/confirmation-dialog/confirmation-dialog.component';
import { ConfirmationDialogConfig } from '@libs/shared/ui/dialogs/confirmation-dialog/confirmation-dialog.type';
import { merge } from 'lodash-es';

@Injectable()
export class ConfirmationDialogService {
  private _defaultConfig: ConfirmationDialogConfig = {
    title: 'Confirm action',
    message: 'Are you sure you want to confirm this action?',
    icon: {
      show: true,
      name: 'heroicons_outline:exclamation-circle',
      color: 'warn',
    },
    actions: {
      confirm: {
        show: true,
        label: '확인',
        color: 'warn',
      },
      cancel: {
        show: true,
        label: '취소',
      },
    },
    dismissible: false,
    submitOnEnter: false,
  };

  constructor(private _matDialog: MatDialog) {}

  open(
    config: ConfirmationDialogConfig = {}
  ): MatDialogRef<ConfirmationDialogComponent, string> {
    // Merge the user config with the default config
    const userConfig = merge({}, this._defaultConfig, config);

    // Open the dialog
    return this._matDialog.open(ConfirmationDialogComponent, {
      autoFocus: false,
      disableClose: !userConfig.dismissible,
      data: userConfig,
      panelClass: 'confirmation-dialog-panel',
    });
  }
}

export function injectConfirmationDialogService(): ConfirmationDialogService {
  return inject(ConfirmationDialogService);
}
